module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    },
    on: {
      "keydown": _vm.handleKeydown
    }
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), (_vm.showConfig) ? _c('config', {
    attrs: {
      "config": _vm.config
    },
    on: {
      "ok": _vm.applyConfig,
      "cancel": function($event) {
        _vm.showConfig = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "actions help",
    attrs: {
      "type": "button",
      "title": "Help on tttimestamps"
    },
    on: {
      "click": _vm.handleShowHelp
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "actions config",
    attrs: {
      "type": "button",
      "title": "Configure tttimestamps"
    },
    on: {
      "click": function($event) {
        _vm.showConfig = true
      }
    }
  })])]), _vm._v(" "), _c('time-table', {
    attrs: {
      "descriptions": _vm.config.descriptions !== false,
      "columns": _vm.columnsWithDefinitions,
      "showHelp": _vm.showHelp
    },
    on: {
      "showConfig": function($event) {
        _vm.showConfig = true
      },
      "hideHelp": _vm.handleHideHelp
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "footer-inner"
    }
  }, [_c('a', {
    staticClass: "footer",
    attrs: {
      "href": "https://tttimestamps.com"
    }
  }, [_vm._v("tttimestamps " + _vm._s(_vm.version))]), _vm._v("\n        •\n        "), _c('a', {
    staticClass: "footer",
    attrs: {
      "href": "/static/history.html"
    }
  }, [_vm._v("history")]), _vm._v("\n        •\n        made with love by "), _c('a', {
    attrs: {
      "href": "http://josdejong.com"
    }
  }, [_vm._v("Jos de Jong")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "https://tttimestamps.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tttimestamps_logo.svg",
      "width": "250",
      "height": "40",
      "alt": "tttimestamps"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social facebook"
  }, [_c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://tttimestamps.com",
      "data-layout": "button",
      "data-action": "like",
      "data-size": "small",
      "data-show-faces": "false",
      "data-share": "false"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social twitter"
  }, [_c('a', {
    staticClass: "twitter-share-button",
    attrs: {
      "href": "https://twitter.com/intent/tweet?text=Check%20out%20this%20handy%20timestamp%20converter",
      "data-size": "small"
    }
  }, [_vm._v("\n            Tweet")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4d69231c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 324
// module chunks = 0